module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "novalidate": "novalidate"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.nextStep($event)
      }
    }
  }, [_c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [(_vm.visible && _vm.currentStep !== _vm.steps.length + 1) ? _c('dots', {
    staticClass: "form__navigation",
    attrs: {
      "items": _vm.steps,
      "current": _vm.currentStep - 1
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "form__content"
  }, [_c('transition', {
    attrs: {
      "appear": "appear",
      "mode": "out-in"
    },
    on: {
      "enter": _vm.stepEnter,
      "leave": _vm.stepLeave
    }
  }, [(_vm.currentStep <= _vm.steps.length) ? _vm._l((_vm.steps), function(step, index) {
    return (_vm.visible && index + 1 === _vm.currentStep) ? _c('div', {
      key: index,
      staticClass: "step"
    }, [_c('div', {
      staticClass: "step__heading",
      attrs: {
        "data-primary": "data-primary"
      },
      domProps: {
        "innerHTML": _vm._s(step.question)
      }
    }), _c('input', {
      ref: "input",
      refInFor: true,
      staticClass: "step__input",
      attrs: {
        "data-secondary": "data-secondary",
        "autocomplete": "off",
        "autocorrect": "off",
        "name": step.name,
        "type": step.type,
        "data-id": step.name,
        "disabled": _vm.sending
      },
      on: {
        "blur": _vm.onBlur,
        "input": _vm.update
      }
    }), _c('transition', {
      attrs: {
        "name": "fade"
      }
    })], 1) : _vm._e()
  }) : (_vm.sending) ? [_c('div', {
    key: "loader",
    staticClass: "step"
  }, [_c('div', {
    staticClass: "loader",
    attrs: {
      "data-primary": "data-primary"
    }
  }), _c('div', {
    staticClass: "loader__label",
    attrs: {
      "data-secondary": "data-secondary"
    }
  }, [_vm._v(_vm._s(_vm.$t('form-sending')))])])] : [_c('div', {
    key: "thank-you",
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step__heading is-large",
    attrs: {
      "data-primary": "data-primary"
    }
  }, [_vm._v(_vm._s(_vm.failed ? _vm.$t('form-fail-title') : _vm.$t('form-thank-title')))]), _c('div', {
    staticClass: "step__subheading",
    attrs: {
      "data-secondary": "data-secondary"
    }
  }, [_vm._v(_vm._s(_vm.failed ? _vm.$t('form-fail-subtitle') : _vm.$t('form-thank-subtitle')))]), _c('base-button', {
    ref: "button",
    staticClass: "step__button",
    attrs: {
      "data-secondary": "data-secondary",
      "url": '/',
      "label": _vm.$t('go-to-homepage')
    },
    nativeOn: {
      "click": function($event) {
        _vm.$store.commit('closePopup')
      }
    }
  })], 1)]], 2)], 1), _c('transition', {
    attrs: {
      "appear": "appear",
      "name": "fade"
    }
  }, [(_vm.visible && _vm.currentStep <= _vm.steps.length) ? _c('div', {
    staticClass: "form__controls controls"
  }, [_c('button', {
    staticClass: "controls-button",
    attrs: {
      "type": "button",
      "disabled": _vm.currentStep <= 1
    },
    on: {
      "click": _vm.prevStep
    }
  }, [_c('div', {
    staticClass: "controls-button__content"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/arrow-prev.svg"),
      "alt": "arrow prev"
    }
  }), _c('span', {
    staticClass: "controls-button__label"
  }, [_vm._v(_vm._s(_vm.$t('form-prev-step')))])])]), _c('div', {
    staticClass: "controls-sep"
  }), _c('button', {
    staticClass: "controls-button",
    attrs: {
      "type": "button",
      "disabled": _vm.currentStep >= _vm.steps.length + 1 || _vm.invalid
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_c('div', {
    staticClass: "controls-button__content"
  }, [_c('span', {
    staticClass: "controls-button__label"
  }, [_vm._v(_vm._s(_vm.$t('form-next-step')))]), _c('img', {
    attrs: {
      "src": require("../../assets/arrow-next.svg"),
      "alt": "arrow next"
    }
  })])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5499fcf6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contacts/feedback-form.vue
// module id = 484
// module chunks = 0